import React from 'react';
import DetailCard, {
  DetailCardItem,
} from '@tcs/common/components/molecules/DetailCard';
import formatDate from '@tcs/common/utils/formatDate';

interface AccountDetailsCardProps {
  accountNumber: string;
  accountType: string;
  status: string;
  effectiveDate: string;
}

const AccountDetailsCard = ({
  accountNumber,
  accountType,
  status,
  effectiveDate,
}: AccountDetailsCardProps) => {
  return (
    <DetailCard title="Account Details">
      <DetailCardItem label="Account Number" value={accountNumber} />
      <DetailCardItem label="Account Type" value={accountType} />
      <DetailCardItem label="Status" value={status} />
      <DetailCardItem
        label="Effective Date"
        value={formatDate(effectiveDate)}
      />
    </DetailCard>
  );
};

export default AccountDetailsCard;
